export const PROMPT_BEFORE_IDLE = 2 * 60 * 1000; // 2 minutes
export const IDP_QUERY_PARAM = "idp";